// extracted by mini-css-extract-plugin
module.exports = {"theme":"#42b983","primary":"#42b983","success":"#388e3c","warning":"#e6a23c","danger":"#f56c6c","info":"#5b9bd5"};